export default {
      id: "dashboard-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#dashboard",
      toString: function () {
        return this.url;
      }
    }